import { CommonSubjectType } from '../../paymentReconciliationModal/types/commonSubjectType'

export enum BillType {
  Bill = 'bill',
  CreditNote = CommonSubjectType.CreditNote,
}
